import React, { Suspense } from 'react';
import { Canvas } from '@react-three/fiber'
import { useGLTF, OrbitControls, useProgress } from '@react-three/drei'
import { useControls } from 'leva'
import { ACESFilmicToneMapping } from 'three';
import './styles.css';

const MODELS = {
  Pistol : 'models/pistol.gltf',
  Shotgun : 'models/shotgun.gltf',
  Binoculars : 'models/binoculars.gltf',
  Revolver : 'models/revolver.gltf',
  SubmachineGun : 'models/ppsh41.gltf',
  Sniper : 'models/sniper.gltf'
}

export default function App() {
  const { model } = useControls({ model: { value: 'Pistol', options: Object.keys(MODELS) } })
  return (
    <>
      {/*<header> {model.toUpperCase()}</header>*/}
      <Suspense fallback={<Loader />}>
        <Canvas antialias = "true"
          onCreated={state => { state.toneMapping = ACESFilmicToneMapping }}
          camera={{ position: [-45, 10, 20], fov: 60 }}>
          {/* <hemisphereLight color="white" groundColor="blue" intensity={0.75} />*/}
          <directionalLight position={[0, 10, 0]} color="white" intensity={2} />
          <spotLight position={[0, 45, 0]} intensity={2.5} penumbra={1} />
          <spotLight position={[45, 0, 0]} intensity={2.5} penumbra={1} />
          <spotLight position={[-45, 0, 0]} intensity={2.5} penumbra={1} />
          <spotLight position={[0, 0, 45]} intensity={2.5} penumbra={1} />
          <spotLight position={[0, 0, -45]} intensity={2.5} penumbra={1} />
          <spotLight position={[0, -45, 0]} intensity={2.5} penumbra={1} />
          <group position={[0, 0, 0]}>
            <Model position={[0, 0, 0]} url={MODELS[model]} />
          </group>
          <OrbitControls />
        </Canvas>
      </Suspense>
    </>
  )
}

function Model({ url, ...props }) {
  const { scene } = useGLTF(url)
  return <primitive object={scene} {...props} />
}

function Loader() {
  const { progress } = useProgress()
  return <div className='loading-bar-wrapper'>
    <div className='loading-bar'>
      <div className='loading-bar-inner' style={{ 'width': Math.round(progress) + '%' }}/>
      <span className='loading-bar-text'>{Math.round(progress)} %</span>
    </div>
  </div>
}
